/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Inject, Injectable } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  BuilderFormSchemaFactory,
  BuilderUserContext,
  FormRootSchema,
  FormState,
  FormStateSchema,
  GtoEntryPoint,
} from '@gh/builder-shared';
import { BuilderPermission } from '@gh/builder-shared-data';
import { getDialogInput, TextTypes, whenCreateOrEditMode } from '@gh/common-shared';
import { FormMode } from '@gh/core-ui';
import { isNil } from 'lodash';
import { TakeOffParam } from '../../resources/estimating-take-off-params-tab.model';

@Injectable()
export class EstimatingTakeOffParamFormState extends FormState<TakeOffParam> {
  constructor(@Inject(MAT_DIALOG_DATA) private dialogData: any,
              schemaFactory: BuilderFormSchemaFactory,
              private userContext: BuilderUserContext) {
    super(schemaFactory);
  }

  get submitValue(): TakeOffParam {
    return this.group.value;
  }

  protected buildSchema(takeOffParam: TakeOffParam, { root }: FormStateSchema): FormRootSchema {
    const { entryPoint } = getDialogInput(this.dialogData) as any;

    const isCreateMode = !takeOffParam.takeOffParamId && this.hasCreatePermission(entryPoint);

    const mode = isCreateMode
      ? FormMode.CreateMode
      : this.userContext.hasPermission(BuilderPermission.Setup.Estimating.TakeOffParameters.EDIT)
        ? FormMode.EditMode
        : FormMode.ViewMode;
    return root({
      enabled: whenCreateOrEditMode(),
      mode,
      children: {
        takeOffParamId: void 0,
        code: { required: true, type: TextTypes.TopCode },
        gtoUom: { required: !!entryPoint },
        gtoStyle: void 0,
        gtoColor: void 0,
        description: void 0,
        version: void 0,
        isActive: void 0,
      },
    });
  }

  private hasCreatePermission(entryPoint?: GtoEntryPoint): boolean {
    if (isNil(entryPoint)) {
      return this.userContext.hasPermission(BuilderPermission.Setup.Estimating.TakeOffParameters.CREATE);
    }

    switch (entryPoint) {
      case GtoEntryPoint.HP:
        return this.userContext.hasPermission(BuilderPermission.Estimating.HouseEstimate.Estimate.CREATE_EDIT);
      case GtoEntryPoint.JE:
        return this.userContext.hasPermission(BuilderPermission.Estimating.JobEstimate.EDIT);
      case GtoEntryPoint.QQ:
        return this.userContext.hasPermission(BuilderPermission.Sales.Leads.EDIT);
      default:
        return false;
    }
  }
}
